import { useContext } from 'react';
import { CitationContext } from './context';
export function useCitation() {
  const machine = useContext(CitationContext);
  if (!machine) {
    throw new Error('useCitation must be used within CitationProvider');
  }
  const {
    state,
    send
  } = machine;
  return {
    isLoading: state.hasTag('loading'),
    isError: state.hasTag('error'),
    citation: state.context.citation,
    fetch: () => send({
      type: 'FETCH'
    })
  };
}